import { HelpChapter, HelpVideo } from "./types";

/** Seconds as m:ss. */
export const formatClock = (seconds: number): string => {
  const whole = Math.floor(Math.max(0, seconds));
  return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, "0")}`;
};

/** The chapter playing at `time`. */
export const chapterAt = (
  chapters: HelpChapter[],
  time: number
): HelpChapter | undefined =>
  [...chapters].reverse().find((chapter) => chapter.start <= time);

/** True when `pathname` is one of the video's pages or below it. */
export const isOnPage = (video: HelpVideo, pathname: string): boolean =>
  video.pages.some((page) => pathname === page || pathname.startsWith(`${page}/`));

const LANGUAGE_LABELS: Record<string, string> = { en: "English", es: "Español" };

/** A locale's name for the language button, e.g. "en" → "English". */
export const languageLabel = (locale: string): string => LANGUAGE_LABELS[locale] ?? locale.toUpperCase();
